/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FitnessTransactionsHistoryDTO } from '../dto';
// @ts-ignore
import type { FitnessVoucherDTO } from '../dto';
// @ts-ignore
import type { ValidationErrorResponseDTO } from '../dto';
/**
 * FitnessApi - axios parameter creator
 * @export
 */
export const FitnessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Exports Fitness Members with according Acctions in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSV: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/fitness/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets one usc voucher for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFitnessVoucher: async (tenantId: string, employeeId: string, voucherId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getFitnessVoucher', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getFitnessVoucher', 'employeeId', employeeId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('getFitnessVoucher', 'voucherId', voucherId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/fitness/vouchers/{voucherId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory: async (tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTransactionHistory', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/fitness/transactionHistory`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all usc vouchers for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFitnessVouchers: async (tenantId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listFitnessVouchers', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('listFitnessVouchers', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/fitness/vouchers`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FitnessApi - functional programming interface
 * @export
 */
export const FitnessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FitnessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Exports Fitness Members with according Acctions in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCSV(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCSV(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FitnessApi.getCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets one usc voucher for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFitnessVoucher(tenantId: string, employeeId: string, voucherId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FitnessVoucherDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFitnessVoucher(tenantId, employeeId, voucherId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FitnessApi.getFitnessVoucher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistory(tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FitnessTransactionsHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistory(tenantId, filter, withAggregations, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FitnessApi.getTransactionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all usc vouchers for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFitnessVouchers(tenantId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FitnessVoucherDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFitnessVouchers(tenantId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FitnessApi.listFitnessVouchers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FitnessApi - factory interface
 * @export
 */
export const FitnessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FitnessApiFp(configuration)
    return {
        /**
         * 
         * @summary Exports Fitness Members with according Acctions in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSV(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getCSV(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets one usc voucher for an employee
         * @param {FitnessApiGetFitnessVoucherRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFitnessVoucher(requestParameters: FitnessApiGetFitnessVoucherRequest, options?: RawAxiosRequestConfig): AxiosPromise<FitnessVoucherDTO> {
            return localVarFp.getFitnessVoucher(requestParameters.tenantId, requestParameters.employeeId, requestParameters.voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FitnessApiGetTransactionHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory(requestParameters: FitnessApiGetTransactionHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<FitnessTransactionsHistoryDTO> {
            return localVarFp.getTransactionHistory(requestParameters.tenantId, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all usc vouchers for an employee
         * @param {FitnessApiListFitnessVouchersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFitnessVouchers(requestParameters: FitnessApiListFitnessVouchersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FitnessVoucherDTO>> {
            return localVarFp.listFitnessVouchers(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFitnessVoucher operation in FitnessApi.
 * @export
 * @interface FitnessApiGetFitnessVoucherRequest
 */
export interface FitnessApiGetFitnessVoucherRequest {
    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetFitnessVoucher
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetFitnessVoucher
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetFitnessVoucher
     */
    readonly voucherId: string
}

/**
 * Request parameters for getTransactionHistory operation in FitnessApi.
 * @export
 * @interface FitnessApiGetTransactionHistoryRequest
 */
export interface FitnessApiGetTransactionHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listFitnessVouchers operation in FitnessApi.
 * @export
 * @interface FitnessApiListFitnessVouchersRequest
 */
export interface FitnessApiListFitnessVouchersRequest {
    /**
     * 
     * @type {string}
     * @memberof FitnessApiListFitnessVouchers
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiListFitnessVouchers
     */
    readonly employeeId: string
}

/**
 * FitnessApi - object-oriented interface
 * @export
 * @class FitnessApi
 * @extends {BaseAPI}
 */
export class FitnessApi extends BaseAPI {
    /**
     * 
     * @summary Exports Fitness Members with according Acctions in CSV format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public getCSV(options?: RawAxiosRequestConfig) {
        return FitnessApiFp(this.configuration).getCSV(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets one usc voucher for an employee
     * @param {FitnessApiGetFitnessVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public getFitnessVoucher(requestParameters: FitnessApiGetFitnessVoucherRequest, options?: RawAxiosRequestConfig) {
        return FitnessApiFp(this.configuration).getFitnessVoucher(requestParameters.tenantId, requestParameters.employeeId, requestParameters.voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FitnessApiGetTransactionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public getTransactionHistory(requestParameters: FitnessApiGetTransactionHistoryRequest, options?: RawAxiosRequestConfig) {
        return FitnessApiFp(this.configuration).getTransactionHistory(requestParameters.tenantId, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all usc vouchers for an employee
     * @param {FitnessApiListFitnessVouchersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public listFitnessVouchers(requestParameters: FitnessApiListFitnessVouchersRequest, options?: RawAxiosRequestConfig) {
        return FitnessApiFp(this.configuration).listFitnessVouchers(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}

